export enum SurveyState {
    UnknownError = 0,
    Loading = 1,
    LoginRequired = 2,
    NoAccess = 3,
    UserNotFound = 4,
    SurveyNotFound = 5,
    SurveyAlreadySubmitted = 6,
    Ready = 7,
    Submitted = 8
}